/**
 * Verdicts tab — the rules, each in its own colour. The same cards also
 * sit on the tab they belong to: list verdict and scaling on List groups,
 * the gateway verdict on Gateways, hit again on General & Slots.
 * (23/10/2026 — "A list fails" is a row of the List verdict's FAIL now.)
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import { StepCardGroup } from '@/components/ui';

import type { DropGenPlanDetail } from '../../../drop-generator.types';
import type { ContainerEditor } from '../state/useContainerEditor';
import { GatewayVerdictCard, HitAgainCard, ListVerdictCard, ScalingCard } from './cards';

export const VerdictsTab: FC<{ editor: ContainerEditor; plan: DropGenPlanDetail; containerId: string | null }> = ({
  editor,
  plan,
  containerId,
}) => {
  if (editor.draft.kind === 'ROUTE_TEST')
    return (
      <StepCardGroup>
        <GatewayVerdictCard index={1} editor={editor} plan={plan} containerId={containerId} />
      </StepCardGroup>
    );
  return (
    <StepCardGroup>
      <ListVerdictCard index={1} editor={editor} plan={plan} containerId={containerId} />
      <GatewayVerdictCard index={2} editor={editor} plan={plan} containerId={containerId} />
      <ScalingCard index={3} editor={editor} plan={plan} containerId={containerId} />
      <HitAgainCard index={4} editor={editor} plan={plan} containerId={containerId} />
    </StepCardGroup>
  );
};
